import { createClient } from '@supabase/supabase-js'

export default {
  useReset: true,
  useVariable: true,
  useFontImport: true,
  useIconSprite: true,
  useSvgSprite: true,
  useDefaultConfig: true,
  useDocumentTheme: true,
  globalTheme: 'dark',
  verbose: false,
  fetch: {
    adapter: 'supabase',
    createClient,
    url: 'https://xhzwvfniejgdvcpobdxm.supabase.co',
    key: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhoend2Zm5pZWpnZHZjcG9iZHhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5MTcxMTksImV4cCI6MjA4OTQ5MzExOX0.G2D-hdPv_ulmiEPS2AXZ2vGaykgvAmgTqU1eyKvLtcw',
    db: {
      schema: 'public'
    },
    retry: { retry: '3', delay: '1000' }
  },
  polyglot: {
    defaultLang: 'en',
    languages: ['en', 'ka', 'ru', 'uk', 'tr', 'zh', 'hi', 'msa'],
    storageLangKey: 'legal_lang',
    storagePrefix: 'legal_t_'
  }
}
